import ApiService from "@/common/api.service";

// action types
export const SAVE_NEWS = "/news/save-news";
export const LIST_NEWS = "/news/list";
export const DETAIL_NEWS = "/news/detail";
export const UPDATE_NEWS = "/news/update";
export const DELETE_NEWS = "/news/delete";
// mutation types
export const SET_LIST_NEWS = "setNews";
export const SET_DETAIL_NEWS = "setDetailNews";
export const SET_ERROR = "setError";

const state = {
    errors: null,
    news: [],
    detail_news: {}
};

const getters = {
    listNews(state) {
        return state.news;
    },
    detailNews(state) {
        return state.detail_news;
    },
};

const actions = {
    [LIST_NEWS](context, payload) {
        return new Promise(resolve => {
            ApiService.query(LIST_NEWS, payload).then(({ data }) => {
                if (data) {
                    context.commit(SET_LIST_NEWS, data);
                }
                resolve(data);
            });
        });
    },
    [DETAIL_NEWS](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(DETAIL_NEWS, payload)
                .then(({ data }) => {
                    context.commit(SET_DETAIL_NEWS, data);
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response);
                    reject(response)
                });
        });
    },
    [SAVE_NEWS](context,payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(SAVE_NEWS, payload)
                .then(data => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response.data.errors);
                    reject(response);
                });
        });
    },
    [UPDATE_NEWS](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(UPDATE_NEWS, payload)
                .then(data => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    },
    [DELETE_NEWS](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${DELETE_NEWS}/${id}`)
                .then(data => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response.data.errors);
                    reject(response);
                });
        });
    },
};

const mutations = {
    [SET_LIST_NEWS](state, data) {
        state.news = data
        state.errors = {};
    },
    [SET_ERROR](state, error) {
        state.errors = error;
    },
    [SET_DETAIL_NEWS](state, data) {
        state.detail_news = data;
        state.errors = {};
    },
};

export default {
    state,
    actions,
    mutations,
    getters
};
